import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function SplashScreen({ onFinish }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // 顯示啟動頁3秒後開始淡出
    const timer = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence onExitComplete={onFinish}>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(160deg, #1d4ed8 0%, #2563eb 40%, #3b82f6 75%, #60a5fa 100%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          {/* 裝飾圓圈 */}
          <div style={{
            position: 'absolute', top: '-80px', right: '-60px',
            width: '260px', height: '260px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.07)', zIndex: 1, pointerEvents: 'none'
          }} />
          <div style={{
            position: 'absolute', bottom: '-60px', left: '-40px',
            width: '200px', height: '200px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)', zIndex: 1, pointerEvents: 'none'
          }} />
          {/* Logo 容器 */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6, ease: 'easeOut' }}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '32px',
              position: 'relative',
              zIndex: 2
            }}
          >
            {/* Logo 圖片 */}
            <div style={{
              width: '160px',
              height: '160px',
              borderRadius: '40px',
              overflow: 'hidden',
              boxShadow: '0 24px 60px rgba(0, 0, 0, 0.25)',
              background: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img
                src="/splash/logo.png"
                alt="JoinU Logo"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div style="
                      font-size: 3rem;
                      font-weight: 900;
                      font-family: Outfit, -apple-system, sans-serif;
                      color: #2563eb;
                    ">J</div>
                  `;
                }}
              />
            </div>

            {/* App 名稱 */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.5 }}
              style={{ textAlign: 'center' }}
            >
              <h1 style={{
                fontSize: '3rem',
                fontWeight: '900',
                fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, 'PingFang TC', sans-serif",
                color: 'white',
                margin: '0 0 12px 0',
                letterSpacing: '-0.03em',
                textShadow: '0 4px 16px rgba(0, 0, 0, 0.2)'
              }}>
                JoinU
              </h1>
              <p style={{
                fontSize: '1rem',
                color: 'rgba(255,255,255,0.85)',
                margin: 0,
                fontWeight: '500',
                letterSpacing: '0.06em',
                lineHeight: '1.7'
              }}>
                讓交友變得更簡單<br />從此揪遊不孤單
              </p>
            </motion.div>

            {/* 載入進度條 */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.3 }}
              style={{ marginTop: '8px' }}
            >
              <div style={{
                width: '120px', height: '3px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '2px', overflow: 'hidden'
              }}>
                <motion.div
                  initial={{ x: '-100%' }}
                  animate={{ x: '100%' }}
                  transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
                  style={{ width: '55%', height: '100%', background: 'white', borderRadius: '2px' }}
                />
              </div>
            </motion.div>
          </motion.div>

          {/* 底部版權資訊 */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            style={{
              position: 'absolute',
              bottom: '40px',
              textAlign: 'center',
              color: 'rgba(255, 255, 255, 1)',
              fontSize: '0.875rem',
              zIndex: 2
            }}
          >
            © 2026 JoinU. All rights reserved.
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
